import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../store/action/exchange';
import intl from "react-intl-universal";
import Modal from '../../components/Common/Modal';
import Address from '../../components/Address';
import {Commun, toast} from "../../utils/axios";
import common from "../../common/common";
import exchange from '../../common/exchange';
import Cookies from 'js-cookie';
import Loading from '../../components/Common/Loading';
import styles from './index.module.scss';
import { isAddressSdkOrg, isAddressSdkUser, openAddressSdk } from '../../common/addressSdk';

class AddressPage extends React.Component {
    constructor(props) {
        super(props);
        this.observer = null;
        this.timer = null;
        this.state = {
            name: '', // 收货人姓名
            phone: '', // 联系人电话
            address: '', // 收货地址
            mainOrgId: '',
            roleId: 0,
            studentInfo: {},
            resolvedU2Token: '',
            loading: true,
            timeout: false,
        }
    }

    componentDidMount() {
        document.title = intl.get('GOODS_RECEIVE_ADDRESS');
        this.fetchData();
        this.timer = setTimeout(() => {
            this.setState({
                timeout: true,
                loading: false
            });
        }, 5000);
    }
   
    fetchData = async () => {
        try {
            await this.getStudentInfo();
            await this.getUserInfo();
        } catch (error) {
            console.error('error', error);
        }
    };

    // 获取用户信息
    getUserInfo = () => {
        Commun.get(`${common.userApiPrefix}/address`).then(res => {
            const { consignee = '', phone = '', address = '' } = res[res.length - 1] || {};
            this.setState({
                name: consignee,
                phone,
                address,
                loading: false
            });
            clearTimeout(this.timer);
            
        }).catch(error => {
            console.log(error);
        });
    };
    getStudentInfo = async () => {
        let res = await Commun.get(`${common.userApiPrefix}/simple-info`);
        this.setState({
            roleId: res.roleId,
        });
        
        if (isAddressSdkOrg(res.mainOrgId)) {
            Commun.get(`${common.userApiPrefix}/u2/token`).then(studentInfo => {
                const { u2Token, mainOrgId } = studentInfo;
                const urlU2Token = common.getSearchParam()?.accessToken || '';
                const resolvedU2Token = u2Token || urlU2Token;
                Cookies.set('U2AT', resolvedU2Token, { domain: '.xdf.cn' });
                this.setState({
                    mainOrgId,
                    studentInfo,
                    resolvedU2Token,
                });
                isAddressSdkUser(mainOrgId, res.roleId) && this.onAddress(studentInfo)
            }).catch(err => {
                console.log('getStudentInfo', err);
            })
        }
    }

    onAddress = async (content) => {
        openAddressSdk({
            mainOrgId: this.state.mainOrgId || content.mainOrgId,
            appId: content.appId,
            relatedCode: content.relatedCode,
            scene: 'addressPage',
            isTest: common.isTest(),
            u2at: this.state.resolvedU2Token,
            onClose: () => {},
            onSuccess: () => {
                this.onSuccess();
            },
            onError: (err) => {
                console.log('error', err);
                toast('地址初始化错误');
            }
        });
        console.log('onAddress')
    }

    // 点击取消按钮(PC端关闭WebView页面)
    onCancel = () => {
        if (!common.isMobileShell()) {
            this.closeWebView('cancel');
        }
    };

    // 保存成功后的回调(PC端关闭WebView页面)
    onSuccess = async () => {
        let curItem = new URLSearchParams(window.location.search).get('curItem');
        if (curItem && Object.prototype.toString.call(curItem) === '[object String]') {
          let currentItem = JSON.parse(curItem);
          try {
              const orderNo = await exchange.createOrder() // 生成订单号
              let res = await exchange.exchangeProduct({ ...currentItem, orderNo }); // 兑换商品
          } catch(error) {
            console.error(error);
          }
          // 移动端-如果是从实物地址那兑换的，提示兑换成功，点好哒返回
          toast(intl.get('SAVE_SUCCESSFUL'));
          Modal.info({
            title: intl.get('EXCHANGE_SUCCESS'),
            content: intl.get('MAIL_TIPS'),
            okText: intl.get('RIGHT_TEXT'),
            onOk: () => {
              if (!common.isMobileShell()) {
                this.closeWebView('ok');
              } else {
                window.history.go(-1);
              }
            }
          });
          return;
        }
        // 移动端-如果是从移动端修改地址那里进来的，点保存直接toast提示保存成功即可
        toast(intl.get('SAVE_SUCCESSFUL'));
        if (!common.isMobileShell()) {
            this.closeWebView('cancel');
        }
        // Modal.info({
        //     content: intl.get('SAVE_SUCCESSFUL'),
        //     onOk: () => {
        //         console.log("保存地址", !common.isMobileShell());
        //         if (!common.isMobileShell()) {
        //             this.closeWebView('ok');
        //         } else {
        //           window.history.go(-1);
        //         }
        //     }
        // });
    };

    // 关闭客户端webView页面
    closeWebView = (value) => {
        Commun.sendClient('closeWeb', value);
    };

    reload = () => {
        window.location.reload(true);
    }

    render() {
        const {
            name,
            phone,
            address,
            loading,
            mainOrgId,
            roleId,
            timeout
        } = this.state;
        const isStudent = roleId == 3
        const isSDKUser = isAddressSdkOrg(mainOrgId)
        return <React.Fragment> 
            {timeout && <div className={styles.timeout}><p>请求超时</p><button onClick={this.reload}>重试</button> </div>}
            {loading && <Loading />}
            {!isStudent && <div className={styles.noSupport}><img src={require('../../assets/img/address/empty.png')}/><p>暂不支持编辑地址</p></div> }
            {(!isSDKUser && isStudent) && 
                <Address
                    name={name}
                    phone={phone}
                    address={address}
                    onSuccess={this.onSuccess}
                    showCancelBtn={!common.isMobileShell()}
                    onCancel={this.onCancel}
                />}
        </React.Fragment>
    }
}

const mapStateToProps = state => ({
  ...state.exchange
});

const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddressPage);